<template>
    <div class="card">
        <div class="card-header border-0">
            <div class="row align-items-center">
                <div class="col text-center">
                    <h3 class="mb-0">PUBLICAÇÕES</h3>
                </div>
            </div>
        </div>
        <div class="row ml-3 mr-3">
            <div class="col-md-7 col-sm-12">
                <base-input v-model="queryTitulo" addon-left-icon="fas fa-search"
                            placeholder="pesquisar título da publicação"></base-input>
            </div>
            <div class="col-md-5 col-sm-12 mb-3">
                <router-link ref="link" class="btn  btn-default" :to="{name: 'pesquisa'}">
                    <i class="fas fa-search"></i> Pesquisa avançada
                </router-link>
            </div>
        </div>

        <div v-show="versaoanterior" class="row ml-3 mr-3">
            <div class="col-12">
                <base-alert type="default">
                    <strong>Publicações indisponíveis.</strong> O diário foi gerado de uma forma que não possibilita a listagem individual das publicações.
                </base-alert>
            </div>
        </div>

        <div v-show="!versaoanterior" class="row">
            <div class="col-12">
                <ul class="listnone">
                    <li class="text-dark font-weight-500" v-for="(item, index) in filterPublicacoes" :key="index">
                        {{item.tit_descricao}}
                        <ul>
                            <ol>
                                <li class="font-weight-300 text-justify mr-4 mb-2"
                                    v-for="(pub, index) in item.publicacoes" :key="index">
                                    {{pub.pub_descricao}}
                                    <a v-bind:href="baseUrl+'diario/publicacao/'+pub.pub_codigo" target="_blank" class="btn btn-outline-secondary btn-sm">Visualizar</a>
                                </li>
                            </ol>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
  import {getBaseURL} from "@/config"
  import {dowloadDiario} from "@/plugins/webdom";

  export default {
    name: 'table-diario-detalhe',
    props: {
      titulos: {
        type: Array,
      },
      versaoanterior: {
        type: Boolean,
      }
    },
    data() {
      return {
        baseUrl: getBaseURL(),
        queryTitulo: ''
      }
    },
    methods: {
      dowload(diario) {
        dowloadDiario(diario)
      }
    },
    computed: {
      filterPublicacoes() {
        return this.titulos.filter(titulo => {
          let flag = false;
          titulo.publicacoes.filter(publicacao => {
            flag = publicacao.pub_descricao.toLowerCase().includes(this.queryTitulo.toLowerCase())
          });
          if (flag) {
            return titulo
          } else {
            return null
          }
        })
      }
    }
  }
</script>
<style>
    .listnone {
        list-style-type: none
    }
</style>
